import React from 'react';
import styles from './index.module.scss';
import HeaderLogoBlock from './header_logo_block';

const HeaderLogo = ({ contentData, path_to_folder, onClick }) => {

  const renderBlock = (contentData, index) => {
    const isLastBlock = index === contentData.length - 1;
    return (
      <HeaderLogoBlock
        key={index}
        blockData={contentData}
        path_to_folder={path_to_folder}
        blockIndex={index}
        isLastBlock={isLastBlock}
      />
    );
  };

  return (
    <div
      className={styles.headerLogo}
      onClick={onClick}
      style={{ cursor: onClick ? 'pointer' : 'default' }}>
      {contentData && Array.isArray(contentData) && contentData[0] && (
        <div className={styles.blocksContainer}>
          {renderBlock(contentData[0], 0)}
        </div>
      )}
    </div>
  );
};

export default HeaderLogo;
